import { BaseTable, CommandButton, JournalTable, Modal, TableHeader,
    JournalLinkedAccount,  JournalLinkedAccountById
 } from "components"
import { Fragment} from "react"
import { convertNumber,  useToggle } from "utils"
import moment from "moment"
import type { FormType } from "../utils"
import { useFormContext } from "react-hook-form"


export function Journal() {
    const { getValues } = useFormContext<FormType>()
    const { isActive, toggle } = useToggle(false)

    const data = getValues()

    return (
        <Fragment>
            <CommandButton actiontype="journal" onClick={toggle} />

            {isActive && (
                <Modal isOpen title="JOURNAL" closeModal={toggle} size="full">
                    <Modal.Body>
                        <JournalTableSection data={data}/>
                    </Modal.Body>
                </Modal>
            )}
        </Fragment>
    )
}

function JournalTableSection(props:{data:FormType}) {
    const transaction_date = props.data.transaction_date
    const trx_code = props.data.trx_code?? '-'
    const detailTransaction = props.data.refund_return_detail
    
    // const [totalDebet, setTotalDebet] = useState<number>(0);
    // const [totalCredit, setTotalCredit] = useState<number>(0);

    return (
        <JournalTable>
            <JournalTable.Content>
                <BaseTable>
                    <TableHeader>
                        <tr>
                            <th className="w-[10px]">DATE</th>
                            <th>IDM</th>
                            <th>ACCOUNT</th>
                            <th>DEBET</th>
                            <th>CREDIT</th>
                        </tr>
                    </TableHeader>
                    <tbody>
                        {detailTransaction.map((item, index) => {
                            let  amount = item.qty_return_item * item.price_refund * ((100 - item.discount)/100)
                            if(item.tax_rate){
                                amount = amount * (100 + item.tax_rate)/100
                            }
                            
                            return (
                                <Fragment key={index}>
                                    {Boolean(amount) && (
                                        <>
                                            <tr>
                                                <td>{moment(transaction_date).format("DD/MM/YYYY")}</td>
                                                <td>{trx_code}</td>
                                                <JournalLinkedAccount coa_code="LA12" />
                                                <td className="text-right">{convertNumber(amount).intoCurrency}</td>
                                                <td></td>
                                            </tr>
 
                                        </>
                                    )}
                                    {Boolean(amount) &&(
                                        <>
                                            {props.data.coa_cheque_id && (
                                                <tr>
                                                    <td>{moment(transaction_date).format("DD/MM/YYYY")}</td>
                                                    <td>{trx_code}</td>
                                                    <JournalLinkedAccountById coa_id={Number(props.data.coa_cheque_id)} />
                                                    <td></td>
                                                    <td className="text-right">{convertNumber(amount).intoCurrency}</td>
                                                </tr>
                                            )}
                                        </>
                                    )}
                                </Fragment>
                            )
                        })}
                    </tbody>
                </BaseTable>
            </JournalTable.Content>
        </JournalTable>
    )
}
